import React from 'react'
import { connect } from 'react-redux';
import { actionCreators } from '../../store/UserData';
import { bindActionCreators } from 'redux';
import { Jumbotron } from 'reactstrap';
import '../../styles/loading.css';
import '../../styles/ThankYou.css';

class ThankYouStep extends React.Component {
    render(){
        let response;
        let responsetext;
        if (this.props.isRegistration) {
            if (this.props.type === "gas") {
                responsetext ="Vielen Dank für Ihre Anmeldung im GASAG | ERDGAS Leerstand. Sie erhalten in Kürze eine Bestätigungsmail mit weiteren Informationen."
            } else {
                if (this.props.additionalGas) {
                    responsetext ="Vielen Dank für Ihre Anmeldung im GASAG | STROM und GASAG | ERDGAS Leerstand. Sie erhalten in Kürze eine Bestätigungsmail mit weiteren Informationen."
                } else {
                    responsetext ="Vielen Dank für Ihre Anmeldung im GASAG | STROM Leerstand. Sie erhalten in Kürze eine Bestätigungsmail mit weiteren Informationen."
                }
            }
        }
        if (this.props.isRegistration === false) {
            if (this.props.type === "gas") {
                responsetext ="Vielen Dank für Ihre Abmeldung des GASAG | ERDGAS Leerstandes. Sie erhalten in Kürze eine Bestätigungsmail mit weiteren Informationen."
            } else {
                if (this.props.additionalGas) {
                    responsetext ="Vielen Dank für Ihre Abmeldung des GASAG | STROM und GASAG | ERDGAS Leerstandes. Sie erhalten in Kürze eine Bestätigungsmail mit weiteren Informationen."
                } else {
                    responsetext ="Vielen Dank für Ihre Abmeldung des GASAG | STROM Leerstandes. Sie erhalten in Kürze eine Bestätigungsmail mit weiteren Informationen."
                }
            }
        }
        if(this.props.isLoading){
            response = 
                <Jumbotron>
                    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                    <h1 className="display-3">Einen Augenblick Geduld</h1>
                    <p className="lead">Die Daten werden übermittelt.</p>
                    <hr className="my-2" />
                    <p>Einen Moment bitte.</p>
                </Jumbotron>
        } else {
            if(this.props.isSuccess){
                response = 
                    <Jumbotron>
                        <h1 className="display-3">Vielen Dank für Ihre Bestellung</h1>
                        <hr className="my-2" />
                        <p>{responsetext}</p>
                    </Jumbotron>
            } else {
                if(this.props.isRegistration === true) {
                    response = 
                    <Jumbotron>
                        <h1 className="display-3">Etwas ging leider schief</h1>
                        <p className="lead">Die angegebene Verbrauchsstelle können wir in unserem System nicht finden.
                          Bitte teilen Sie uns Ihre Anfrage zur Leerstandsanmeldung per <a href="https://www.gasag.de/kundenservice/servicethemen" target="_blank">Kontaktformular</a> mit.</p>
                        <hr className="my-2" />
                        <p>Fehlercode: {this.props.errorCode}</p>
                    </Jumbotron>
                }
                else {
                    response = 
                    <Jumbotron>
                        <h1 className="display-3">Etwas ging leider schief</h1>
                        <p className="lead">Die Übermittlung der Daten hat leider nicht geklappt.</p>
                        <hr className="my-2" />
                        <p>Fehlercode: {this.props.errorCode}</p>
                    </Jumbotron>
                }
            }
        }
        return(
            <div>
                {response}
            </div>
        )
    }
}


export default connect(
    state => state.userData,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(ThankYouStep);


// WEBPACK FOOTER //
// ./src/components/Steps/ThankYouStep.js